export enum GroupType {
  Bill,
  Debt,
  Investment
}